import { render, staticRenderFns } from "./ErrorHandler.vue?vue&type=template&id=234fe4a8&scoped=true"
import script from "./ErrorHandler.vue?vue&type=script&lang=js"
export * from "./ErrorHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../CitizenPortalUI_Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234fe4a8",
  null
  
)

export default component.exports